class WindowProxy {
    get() {
        return typeof window !== 'undefined' && window;
    }

    location() {
        return typeof window !== 'undefined' && window.location;
    }

    localStorage() {
        return typeof window !== 'undefined' && window.localStorage;
    }

    sessionStorage() {
        return typeof window !== 'undefined' && window.sessionStorage;
    }

    getFBApi() {
        return typeof window !== 'undefined' && window.FB;
    }
}

export default new WindowProxy();



// WEBPACK FOOTER //
// ./src/services/WindowProxy/WindowProxy.js